// src/pages/PagoPendiente.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verificarPagoMP } from '../services/api';

const PagoPendiente = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [segundos, setSegundos] = useState(30);
  const [verificando, setVerificando] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const paymentId = searchParams.get('payment_id');
  const preferenceId = searchParams.get('preference_id');

  useEffect(() => {
    // Verificar el estado del pago automáticamente
    if (paymentId) {
      verificarPago();
    }

    // Contador regresivo
    const timer = setInterval(() => {
      setSegundos(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [paymentId]);

  useEffect(() => {
    if (segundos === 0) {
      navigate('/krums');
    }
  }, [segundos, navigate]);

  const verificarPago = async () => {
    setVerificando(true);
    try {
      const response = await verificarPagoMP(paymentId);
      if (response.data.status === 'approved') {
        setMensaje('✅ ¡Pago confirmado! Serás redirigido...');
        setTimeout(() => navigate('/krums?exito=true'), 2000);
      } else if (response.data.status === 'rejected') {
        setMensaje('❌ Pago rechazado');
        setTimeout(() => navigate('/krums'), 3000);
      } else {
        setMensaje('⏳ Pago pendiente, espera la confirmación...');
      }
    } catch (error) {
      console.error('Error verificando pago:', error);
    } finally {
      setVerificando(false);
    }
  };

  return (
    <div className="pago-pendiente-container">
      <div className="pago-pendiente-card">
        <div className="pendiente-icon">⏳</div>
        <h1>Pago pendiente</h1>
        
        <div className="instrucciones-pago">
          <h3>Instrucciones para completar tu pago:</h3>
          
          <div className="metodo-pago-info">
            <h4>💵 Pago en efectivo (OXXO)</h4>
            <p>Si elegiste pagar en efectivo:</p>
            <ol>
              <li>Acude a cualquier tienda OXXO</li>
              <li>Muestra el código de barras o el número de referencia</li>
              <li>Realiza el pago en efectivo</li>
              <li>Los Krums se acreditarán automáticamente al confirmar el pago</li>
            </ol>
          </div>

          <div className="metodo-pago-info">
            <h4>🏦 Transferencia bancaria</h4>
            <p>Si elegiste transferencia:</p>
            <ol>
              <li>Realiza la transferencia desde tu banca en línea</li>
              <li>Usa los datos proporcionados por Mercado Pago</li>
              <li>El pago puede tardar hasta 24 horas en confirmarse</li>
            </ol>
          </div>

          <div className="metodo-pago-info">
            <h4>💳 Pago con tarjeta</h4>
            <p>Si pagaste con tarjeta y ves este mensaje:</p>
            <ul>
              <li>El pago está siendo procesado por tu banco</li>
              <li>Normalmente se confirma en segundos</li>
              <li>Puede tardar hasta 24 horas en casos excepcionales</li>
            </ul>
          </div>
        </div>

        {mensaje && (
          <div className="mensaje-pago pendiente">
            {mensaje}
          </div>
        )}

        <div className="contador-redireccion">
          <p>Redirigiendo a la tienda en <strong>{segundos}</strong> segundos...</p>
        </div>

        <div className="acciones-pago">
          <button 
            onClick={verificarPago} 
            disabled={verificando}
            className="btn-verificar"
          >
            {verificando ? 'Verificando...' : 'Verificar estado del pago'}
          </button>
          
          <button 
            onClick={() => navigate('/krums')}
            className="btn-cancelar"
          >
            Volver a la tienda
          </button>
        </div>

        <p className="nota-pago">
          ⚠️ No cierres esta página hasta que el pago sea confirmado.
          Los Krums se acreditarán automáticamente cuando el pago sea aprobado.
        </p>
      </div>
    </div>
  );
};

export default PagoPendiente;